import { RootContainer } from '../../../../core/root_container';
import { ItemSearchJsEnv } from '../../models/item_search_js_env';
import { Button, initItemSearchModal } from '../inputs'
import { checkBoxList } from '../inputs'
import { ItemSearchAction } from '../../actions/item_search_action'

export class ItemSearchContainer extends RootContainer<ItemSearchJsEnv> {
  constructor(model: ItemSearchJsEnv) {
    super();
    this.mount(Button, 'js-item-search-button');
    this.mount(checkBoxList, 'js-item-search-checkbox');
    this.update(model);

    initItemSearchModal()

    ItemSearchAction.UPDATE_EVENT.on((itemSearch: ItemSearchJsEnv) => {
        this.update(itemSearch);
    });
  }
}
